<template>
    <div class="hello">
        <h1>Error 404</h1>
        <strong>Sidan finns tyvärr inte.</strong>
    </div>
</template>

<script>
import Footer from "./Footer";
export default {
    components: {Footer},
  name: 'Kontakt',
  props: {
    msg: String
  }
}
</script>

<style scoped>
    h1 {
        color: #c0392b;
        font-size: 92px;
        text-align: center;
        margin: 100px 0 0 0;
    }
    strong {
        font-size: 64px;
        text-align: center;
        display: block
    }
</style>
